// @ts-expect-error the dist file has no typings; it is the module 'inputmask' resolves to
import * as dist from 'inputmask/dist/inputmask.js'

// inputmask is a UMD bundle whose exports are `{ __esModule: true, default: Inputmask }`.
// Vite 8 (rolldown) pre-bundles an ES module's `import Inputmask from 'inputmask'` Node-style, which ignores
// `__esModule` and hands back the whole exports object, so `new Inputmask()` throws "is not a constructor".
// Aliased in vite.config.ts for every importer, @tsyl/zapan2 included.
// Checked against inputmask 5.0.9 (pinned in package.json): the bundle ends with `e.default = a.default` on `{ __esModule }`.
// On a bump, re-run inputmaskPrebundle.test.ts and inputmaskShim.test.ts.
const exported = (dist as unknown as { default: { default?: unknown } }).default
// The parts of the API @tsyl/zapan2 uses
interface InputmaskStatic {
  new (options?: unknown): { mask: (element: unknown) => unknown }
  isValid: (value: string, options?: unknown) => boolean
}

const Inputmask = (exported.default ?? exported) as InputmaskStatic

export default Inputmask
